import React from "react";
import moment from "moment";
import html2pdf from "html2pdf.js";

function GeneratePerformanceReport({
  data,
  payload,
  username,
  setData,
  setShowPerformancePopup,
}) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  function generatePerformanceReportHTML(data, username) {
    return `
    <div style="padding:0;font-family:sans-serif;">
  
      <div style="text-align:center;">
        <h2>ROSS BOILERS</h2>
        <p>No.33, Burhani Industrial Estate, Kondhwa (Bk), Pune - 411048</p>
        <h3>Technician Performance Report from ${moment(
          new Date(payload.FromDate)
        ).format("DD/MM/YYYY")} to ${moment(new Date(payload.ToDate)).format(
      "DD/MM/YYYY"
    )}</h3>
      </div>
  
      <br/>
  
      <p><strong>Technician: </strong>${username}</p>
  
      <table border="1"
        cellspacing="0"
        cellpadding="6"
        width="100%"
        style="border-collapse:collapse;text-align:center;">
  
        <thead>
          <tr>
            <th>Technician</th>
            <th>Month</th>
            <th>CTC</th>
            <th>Expenses</th>
            <th>Total Cost</th>
            <th>Service Income</th>
            
            <th>Service Days (Pune -> Pune)</th>
            <th style="background-color: yellow;">Number of factory Days</th>
            <th>Factory work value</th>
            <th>Profit/ Loss</th>
            <th style="background-color: yellow;">Number of days at site</th>
            <th>Payment Received</th>
            <th>Payment Balance</th>  
          </tr>
        </thead>
  
        <tbody>
          <tr>
              <td rowspan="13">
                ${username}
              </td>
          ${data
            ?.map(
              (v, i) => `
            <tr>
              ${
                i === data?.length - 1
                  ? `<td>
                ${v?.year}
              </td>`
                  : ""
              }
  
              <td>
                ${v?.month ? months[v?.month - 1] : ""}
              </td>
  
              <td>
                ${parseFloat(v?.salary).toFixed(2)}
              </td>
  
              <td>
                ${v?.voucherAmount}
              </td>
              <td>
                ${parseFloat(v?.totalCost).toFixed(2)}
              </td>
              
              <td>
                ${v?.invoiceAmount}
              </td>
              <td>${v?.serviceDays ?? ""}</td>
              <td>
               ${v?.numberOfDays ?? 0}
              </td>
              ${
                i === data?.length - 1
                  ? `<td></td>`
                  : `<td>${v?.factoryWorkValue ?? 0}</td>`
              }
              
              
              <td>${parseFloat(v?.profitLoss).toFixed(2)}</td>
              <td>${v?.siteDays ?? ""}</td>
               <td>${
                 v?.paymentReceived
                   ? "Yes"
                   : v?.paymentReceived === false
                   ? "N/A"
                   : ""
               }</td>
              <td>${v?.paymentBalance}</td> 
            </tr>
          `
            )
            .join("")}
        </tbody>
      </table>
  
    </div>
    `;
  }
  const headerStyle = {
    backgroundColor: "#1f3b73",
    color: "#fff",
    padding: "12px",
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "600",
  };

  const highlightHeaderStyle = {
    backgroundColor: "#ffc107",
    color: "#000",
    padding: "12px",
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "600",
  };

  const cellStyle = {
    border: "1px solid #e5e5e5",
    textAlign: "center",
  };
  return (
    <div
      style={{
        backgroundColor: "#f4f7fa",
        padding: "30px",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "16px",
          padding: "24px",
          boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
        }}
      >
        <div
          style={{
            textAlign: "center",
            marginBottom: "24px",
          }}
        >
          <h1
            style={{
              margin: 0,
              color: "#1f3b73",
              fontSize: "32px",
              fontWeight: "700",
            }}
          >
            ROSS BOILERS
          </h1>

          <p
            style={{
              color: "#666",
              margin: "8px 0",
            }}
          >
            No.33, Burhani Industrial Estate, Kondhwa (Bk), Pune - 411048
          </p>

          <h2
            style={{
              color: "#222",
              marginTop: "15px",
            }}
          >
            Technician Performance Report
          </h2>

          <span
            style={{
              display: "inline-block",
              marginTop: "10px",
              padding: "8px 16px",
              borderRadius: "20px",
              backgroundColor: "#eef4ff",
              color: "#1f3b73",
              fontWeight: "600",
            }}
          >
            {moment(payload?.FromDate).format("DD/MM/YYYY")} -{" "}
            {moment(payload?.ToDate).format("DD/MM/YYYY")}
          </span>
        </div>
        <button
          style={{ float: "inline-end", cursor: "pointer" }}
          onClick={() => {
            const html = generatePerformanceReportHTML(data, username);
            const element = document.createElement("div");
            element.innerHTML = html;

            const options = {
              margin: 0.5,
              filename: `performance${Date.now()}.pdf`,
              image: { type: "jpeg", quality: 1 },
              html2canvas: { scale: 2 },
              jsPDF: {
                unit: "in",
                format: "a4",
                orientation: "landscape",
              },
            };

            html2pdf()
              .set(options)
              .from(element)
              .save()
              .then(() => {
                setShowPerformancePopup(false);
              });
          }}
        >
          Generate Pdf
        </button>
        <div
          style={{
            marginBottom: "20px",
            fontSize: "16px",
          }}
        >
          <strong>Technician:</strong> {username}
        </div>

        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: "13px",
            }}
          >
            <thead>
              <tr>
                <th style={headerStyle}>Technician</th>
                <th style={headerStyle}>Month</th>
                <th style={headerStyle}>CTC</th>
                <th style={headerStyle}>Expenses</th>
                <th style={headerStyle}>Total Cost</th>
                <th style={headerStyle}>Service Income</th>
                <th style={headerStyle}>Service Days (Pune → Pune)</th>
                <th
                  style={{
                    ...highlightHeaderStyle,
                  }}
                >
                  Number of Factory Days
                </th>
                <th style={headerStyle}>Factory Work Value</th>

                <th style={headerStyle}>Profit / Loss</th>
                <th
                  style={{
                    ...highlightHeaderStyle,
                  }}
                >
                  Number of Days at Site
                </th>
                <th style={headerStyle}>Payment Received</th>
                <th style={headerStyle}>Payment Balance</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td style={cellStyle} rowSpan={13}>
                  {username}
                </td>
              </tr>
              {data?.map((v, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#fff" : "#f9fbff",
                  }}
                >
                  {index == data?.length - 1 && (
                    <td style={cellStyle}>{v?.year}</td>
                  )}

                  <td style={cellStyle}>{months[v?.month - 1]}</td>

                  <td style={cellStyle}>
                    ₹{parseFloat(v?.salary || 0).toFixed(2)}
                  </td>

                  <td style={cellStyle}>
                    ₹{parseFloat(v?.voucherAmount || 0).toFixed(2)}
                  </td>
                  <td style={cellStyle}>
                    ₹{parseFloat(v?.totalCost || 0).toFixed(2)}
                  </td>
                  <td style={cellStyle}>
                    ₹{parseFloat(v?.invoiceAmount || 0).toFixed(2)}
                  </td>
                  <td style={cellStyle}>{v?.serviceDays}</td>
                  <td style={cellStyle}>
                    {index === data?.length - 1 ? (
                      <></>
                    ) : (
                      <input
                        type="number"
                        placeholder="Enter Days"
                        style={{ border: 0, padding: "0.5rem" }}
                        min={0}
                        onChange={(e) => {
                          setData((prev) =>
                            prev.map((x, j) =>
                              j === index
                                ? {
                                    ...x,
                                    numberOfDays: e.target.value,
                                  }
                                : x
                            )
                          );
                        }}
                      />
                    )}
                  </td>
                  <td style={cellStyle}>
                    {index === data?.length - 1 ? (
                      <></>
                    ) : (
                      <input
                        type="text"
                        placeholder="Enter Factory Work Value"
                        style={{ border: 0, padding: "0.5rem" }}
                        value={String(v?.factoryWorkValue ?? "")}
                        onChange={(e) => {
                          const value = e.target.value;

                          // Allow only numbers with up to 2 decimal places
                          if (/^\d*\.?\d{0,2}$/.test(value)) {
                            setData((prev) =>
                              prev.map((x, j) =>
                                j === index
                                  ? {
                                      ...x,
                                      factoryWorkValue: value,
                                    }
                                  : x
                              )
                            );
                          }
                        }}
                      />
                    )}
                  </td>
                  <td
                    style={{
                      ...cellStyle,
                      color:
                        parseFloat(v?.profitLoss).toFixed(2) >= 0
                          ? "#16a34a"
                          : "#dc2626",
                      fontWeight: "700",
                    }}
                  >
                    ₹{parseFloat(v?.profitLoss || 0).toFixed(2)}
                  </td>

                  <td style={cellStyle}>
                    {index === data?.length - 1 ? (
                      <></>
                    ) : (
                      <input
                        type="number"
                        placeholder="Enter Days"
                        style={{ border: 0, padding: "0.5rem" }}
                        min={0}
                        onChange={(e) => {
                          setData((prev) =>
                            prev.map((x, j) =>
                              j === index
                                ? {
                                    ...x,
                                    siteDays: e.target.value,
                                  }
                                : x
                            )
                          );
                        }}
                      />
                    )}
                  </td>
                  <td style={cellStyle}>
                    <span
                      style={{
                        backgroundColor: v?.paymentReceived
                          ? "#dcfce7"
                          : "#fee2e2",
                        color: v?.paymentReceived ? "#166534" : "#991b1b",
                        padding: "4px 10px",
                        borderRadius: "20px",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}
                    >
                      {v?.paymentReceived
                        ? "Yes"
                        : v?.paymentReceived === false
                        ? "N/A"
                        : ""}
                    </span>
                  </td>

                  <td style={cellStyle}>
                    ₹{parseFloat(v?.paymentBalance || 0).toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default GeneratePerformanceReport;
